import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { sportCategories } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500 tracking-wider">九州体育</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {sportCategories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a href="#" className="px-5 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              会员注册
            </a>
            <a href="#" className="px-5 py-2 border border-primary-500 text-primary-500 rounded-lg text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
              App下载
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          <Link to="/" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">首页</Link>
          {sportCategories.map((cat) => (
            <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">{cat.name}</Link>
          ))}
          <Link to="/about" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">关于我们</Link>
          <div className="flex gap-2 pt-2">
            <a href="#" className="flex-1 text-center px-4 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer">会员注册</a>
            <a href="#" className="flex-1 text-center px-4 py-2.5 border border-primary-500 text-primary-500 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer">App下载</a>
          </div>
        </div>
      )}
    </nav>
  );
}